import axios, { AxiosRequestConfig } from 'axios';

// Set config defaults when creating the instance
const httpRequest = axios.create({
  baseURL: process.env.REACT_APP_PROVIDER_URL,
  headers: {
    countryCode: (localStorage.getItem('countryCode') || process.env.REACT_APP_COUNTRYCODE) as string,
    languageCode: (process.env.REACT_APP_LANGUAGECODE) as string
  }
});

const reqInterceptor = async (req: AxiosRequestConfig) => {
  if(!req.headers?.externalName === null) {
    delete req.headers?.externalName;
  }
  if (req.headers && !req.headers?.externalName) {
    //  FIXME: Quick workaround
    const url = new URL(window.location.toString());
    if (url.searchParams.get('variant') === 'ford') {
      req.headers['externalName'] = 'ford';
    }
  }  
  req.headers = {
    ...req.headers,
  }
  return req;
};

httpRequest.interceptors.request.use(reqInterceptor, error => Promise.reject(error));

export default httpRequest;
